
import React from 'react';
import parse from 'html-react-parser';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Utility/Public/css/toastify.css'

class Utility {

    static toastNotifications = (message, title, type, autoclose = true, companyLogo = "", component = <></>) => {
        let errorToastId = "";
        let warningToastId = "";
        let callbackToastId = "";
        //success toast message
        if (type === "success") {
            let _autoclose = 4000;
            if (autoclose === false) {
                _autoclose = autoclose
            }
            toast.success(
                <div className="tostify-inner-box">
                    <div className="iconbox">
                        <div className="alert_img">&nbsp;</div>
                    </div>
                    <div className="titleanddescriptionbox">
                        <h1>{title}</h1>
                        <div className="alert_box">
                            <div className="message_dec">{parse(message)}</div>
                        </div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            });
        } else if (type === "reminder") { // reminder toast notification
            let _autoclose = 4000;
            if (autoclose === false) {
                _autoclose = autoclose
            }
            toast.success(
                <div className='alert_box_reminder'>
                    <h1>{title}</h1>
                    <div className="alert_box">
                        <div className="alert_img_reminder">&nbsp;</div>
                        <div className="message_dec">{parse(message)}</div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false,
                closeOnClick: true
            });
        } else if (type === "info") { // info toast notification
            let _autoclose = 4000;
            if (autoclose === false) {
                _autoclose = autoclose
            }
            toast.success(
                <div>
                    <h1 className="info_title_text">{title}</h1>
                    <div className="alert_box">
                        <div className="alert_img_info"><img src={companyLogo} alt="No image" /></div>
                        <div className="message_dec">{parse(message)}</div>
                    </div>
                </div>, {
                position: 'bottom-left',
                autoClose: _autoclose,
                transition: toast.slide,
                hideProgressBar: false
            });
        } else if (type === "error") { //error toast notification
            console.log('message',message)
            errorToastId = message;
            let _autoclose = 4000;
            if (autoclose === false) {
                _autoclose = autoclose
            }
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="tostify-inner-box errorToastMsg">
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                <div className="message_dec">{message || ""}</div>
                            </div>
                        </div>
                        <div className="iconbox">
                            <div className="alert_img_error">&nbsp;</div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                });
            }

        } else if (type === "warning") { // warning toast notification
            warningToastId = message;
            let _autoclose = 4000;
            if (autoclose === false) {
                _autoclose = autoclose
            }
            if (!toast.isActive(warningToastId)) {
                toast.warning(
                    <div className="tostify-inner-box">
                        <div className="iconbox">
                            <div className="alert_img_warning">&nbsp;</div>
                        </div>
                        <div className="titleanddescriptionbox">
                            <h1>{title}</h1>
                            <div className="alert_box">
                                {/* <div className="message_dec">{parse(message)}</div> */}
                                <div className="message_dec">
                                    {message.split("\n").map((line, index) => (
                                        <p key={index}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: _autoclose,
                    transition: toast.slide,
                    hideProgressBar: false,
                    toastId: warningToastId,
                    closeOnClick: true
                });
            }
        } else if (type === "longError") { // long error toast notification
            errorToastId = message;
            if (!toast.isActive(errorToastId)) {
                toast.error(
                    <div className="warning_message_box_long">
                        <div className="iconbox">
                            <div className="alert_img_warning" >&nbsp;</div>
                        </div>
                        <h1 className="error_title">{title}</h1>
                        <div className="message_descriptipn error_title_dec">{parse(message)}</div>
                    </div>, {
                    position: 'bottom-left',
                    autoClose: false,
                    transition: toast.slide,
                    hideProgressBar: true,
                    toastId: errorToastId,
                    closeOnClick: true
                });
            }

        } else if (type === "callback") {  // callback type toast notification
            callbackToastId = message;
            if (!toast.isActive(callbackToastId)) {
                toast(component, {
                    position: toast.POSITION.TOP_LEFT,
                    transition: toast.slide,
                    toastId: callbackToastId,
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    closeButton: false
                });
            }
        }
    }

    static getExpiryDetails = (expiresIn) => {
        var today = new Date();
        var afterAddWithToday = new Date();
        afterAddWithToday.setSeconds(afterAddWithToday.getSeconds() + (expiresIn - 900));
        let data = {};
        data["loggedInTime"] = today.getTime();
        data["expiryTime"] = afterAddWithToday.getTime();
        data["expiryInterval"] = expiresIn;
        return data;
    }

    //image type file accect fn
    static acceptFileType = () => {
        let fileType = ".jpg, .jpeg, .png"
        return fileType;
    }

    //check file type according to incoming file type
    static checkFileType(file, allowedTypes) {
        const allowedTypesArray = allowedTypes.split(',').map(type => type.trim());
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const arr = new Uint8Array(reader.result.slice(0, 4));
                const header = Array.from(arr, byte => byte.toString(16).padStart(2, '0')).join('');
                const magicNumbers = {
                    'jpg': 'ffd8ffe0',
                    'jpeg': 'ffd8ffe1',
                    'png': ['89504e47', '0000001c'],
                    'xls': ['d0cf11e0', '496e6475'],  // Legacy Excel files
                    'xlsx': ['504b0304', '496e6475'],  // Open XML Excel files (also matches ZIP files)
                    'pdf': '25504446',
                    'csv': [null, '22426f6f', '534c2e20'],  // CSV files don't have a specific magic number
                    'doc': 'd0cf11e0',  // Legacy Word files
                    'docx': '504b0304'
                };

                for (let type of allowedTypesArray) {
                    const typeWithoutDot = type.replace('.', '');
                    const magicNumber = magicNumbers[typeWithoutDot];
                    if (Array.isArray(magicNumber)) {
                        if (magicNumber.includes(header)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    } else {
                        if (header.startsWith(magicNumber)) {
                            resolve({ isValid: true, fileType: type });
                            return;
                        }
                    }
                }

                // If file type doesn't match any of the allowed types
                const detectedType = file.type.split('/')[1];
                resolve({ isValid: false, fileType: detectedType });
            };

            reader.onerror = () => {
                reject("Error reading file");
            };

            // Read the file
            reader.readAsArrayBuffer(file);
        });
    }

    static getUniqueOptions = (data, key) => {
        const uniqueValues = [...new Set(data.map(item => item[key]))];
        return uniqueValues.map(value => ({ name: value }));
    };

    static getUniqueOptionsByKey = (data, key) => {
        const seen = new Set();
        const result = [];

        for (const item of data) {
            const value = item[key];
            if (value && !seen.has(value)) {
                seen.add(value);
                result.push({ id: item.id, name: value });
            }
        }

        return result;
    };
    static getUniqueByName = (items, key) => {
        const seen = new Set();
        return items.filter((item) => {
            const name = item[key];
            if (seen.has(name)) return false;
            seen.add(name);
            return true;
        }).map(item => ({ name: item[key] }));
    };

    static getUniqueByIdName = (items, key, keyName) => {
        const seen = new Set();
        return items.filter((item) => {
            const name = item[key];
            if (seen.has(name)) return false;
            seen.add(name);
            return true;
        }).map(item => ({ id: item[key], name: item[keyName] }));
    };

    static getFileExtension(filename) {
        if (filename) {
            return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
        }
    }
    static getLanguageCode(language) {
        const languageMap = {
            "Afrikaans": "af",
            "Albanian": "sq",
            "Amharic": "am",
            "Arabic": "ar",
            "Armenian": "hy",
            "Azerbaijani": "az",
            "Basque": "eu",
            "Belarusian": "be",
            "Bengali": "bn",
            "Bosnian": "bs",
            "Bulgarian": "bg",
            "Catalan": "ca",
            "Cebuano": "ceb",
            "Chinese": "zh",
            "Corsican": "co",
            "Croatian": "hr",
            "Czech": "cs",
            "Danish": "da",
            "Dutch": "nl",
            "English": "en",
            "Esperanto": "eo",
            "Estonian": "et",
            "Finnish": "fi",
            "French": "fr",
            "Frisian": "fy",
            "Galician": "gl",
            "Georgian": "ka",
            "German": "de",
            "Greek": "el",
            "Gujarati": "gu",
            "Haitian Creole": "ht",
            "Hausa": "ha",
            "Hawaiian": "haw",
            "Hebrew": "he",
            "Hindi": "hi",
            "Hmong": "hmn",
            "Hungarian": "hu",
            "Icelandic": "is",
            "Igbo": "ig",
            "Indonesian": "id",
            "Irish": "ga",
            "Italian": "it",
            "Japanese": "ja",
            "Javanese": "jv",
            "Kannada": "kn",
            "Kazakh": "kk",
            "Khmer": "km",
            "Korean": "ko",
            "Kurdish": "ku",
            "Kyrgyz": "ky",
            "Lao": "lo",
            "Latin": "la",
            "Latvian": "lv",
            "Lithuanian": "lt",
            "Luxembourgish": "lb",
            "Macedonian": "mk",
            "Malagasy": "mg",
            "Malay": "ms",
            "Malayalam": "ml",
            "Maltese": "mt",
            "Maori": "mi",
            "Marathi": "mr",
            "Mongolian": "mn",
            "Myanmar (Burmese)": "my",
            "Nepali": "ne",
            "Norwegian": "no",
            "Nyanja (Chichewa)": "ny",
            "Pashto": "ps",
            "Persian": "fa",
            "Polish": "pl",
            "Portuguese": "pt",
            "Punjabi": "pa",
            "Romanian": "ro",
            "Russian": "ru",
            "Samoan": "sm",
            "Scots Gaelic": "gd",
            "Serbian": "sr",
            "Sesotho": "st",
            "Shona": "sn",
            "Sindhi": "sd",
            "Sinhala (Sinhalese)": "si",
            "Slovak": "sk",
            "Slovenian": "sl",
            "Somali": "so",
            "Spanish": "es",
            "Sundanese": "su",
            "Swahili": "sw",
            "Swedish": "sv",
            "Tagalog (Filipino)": "tl",
            "Tajik": "tg",
            "Tamil": "ta",
            "Telugu": "te",
            "Thai": "th",
            "Turkish": "tr",
            "Ukrainian": "uk",
            "Urdu": "ur",
            "Uzbek": "uz",
            "Vietnamese": "vi",
            "Welsh": "cy",
            "Xhosa": "xh",
            "Yiddish": "yi",
            "Yoruba": "yo",
            "Zulu": "zu"
        };
        const lang_code = languageMap[language] || "en";
        return lang_code;
    }

    static LANGUAGE_OPTIONS = [
        { code: "aa", value: "Afar", label: "Afar" },
        { code: "ab", value: "Abkhazian", label: "Abkhazian" },
        { code: "ae", value: "Avestan", label: "Avestan" },
        { code: "af", value: "Afrikaans", label: "Afrikaans" },
        { code: "ak", value: "Akan", label: "Akan" },
        { code: "am", value: "Amharic", label: "Amharic" },
        { code: "an", value: "Aragonese", label: "Aragonese" },
        { code: "ar", value: "Arabic", label: "Arabic" },
        { code: "as", value: "Assamese", label: "Assamese" },
        { code: "av", value: "Avaric", label: "Avaric" },
        { code: "ay", value: "Aymara", label: "Aymara" },
        { code: "az", value: "Azerbaijani", label: "Azerbaijani" },
        { code: "ba", value: "Bashkir", label: "Bashkir" },
        { code: "be", value: "Belarusian", label: "Belarusian" },
        { code: "bg", value: "Bulgarian", label: "Bulgarian" },
        { code: "bi", value: "Bislama", label: "Bislama" },
        { code: "bm", value: "Bambara", label: "Bambara" },
        { code: "bn", value: "Bengali", label: "Bengali" },
        { code: "bo", value: "Tibetan", label: "Tibetan" },
        { code: "br", value: "Breton", label: "Breton" },
        { code: "bs", value: "Bosnian", label: "Bosnian" },
        { code: "ca", value: "Catalan", label: "Catalan" },
        { code: "ceb", value: "Cebuano", label: "Cebuano" },
        { code: "ch", value: "Chamorro", label: "Chamorro" },
        { code: "co", value: "Corsican", label: "Corsican" },
        { code: "cr", value: "Cree", label: "Cree" },
        { code: "cs", value: "Czech", label: "Czech" },
        { code: "cy", value: "Welsh", label: "Welsh" },
        { code: "da", value: "Danish", label: "Danish" },
        { code: "de", value: "German", label: "German" },
        { code: "dv", value: "Divehi", label: "Divehi" },
        { code: "dz", value: "Dzongkha", label: "Dzongkha" },
        { code: "ee", value: "Ewe", label: "Ewe" },
        { code: "el", value: "Greek", label: "Greek" },
        { code: "en", value: "English", label: "English" },
        { code: "eo", value: "Esperanto", label: "Esperanto" },
        { code: "es", value: "Spanish", label: "Spanish" },
        { code: "et", value: "Estonian", label: "Estonian" },
        { code: "eu", value: "Basque", label: "Basque" },
        { code: "fa", value: "Persian", label: "Persian" },
        { code: "ff", value: "Fulah", label: "Fulah" },
        { code: "fi", value: "Finnish", label: "Finnish" },
        { code: "fj", value: "Fijian", label: "Fijian" },
        { code: "fo", value: "Faroese", label: "Faroese" },
        { code: "fr", value: "French", label: "French" },
        { code: "fy", value: "Frisian", label: "Frisian" },
        { code: "ga", value: "Irish", label: "Irish" },
        { code: "gd", value: "Scots Gaelic", label: "Scots Gaelic" },
        { code: "gl", value: "Galician", label: "Galician" },
        { code: "gn", value: "Guarani", label: "Guarani" },
        { code: "gu", value: "Gujarati", label: "Gujarati" },
        { code: "gv", value: "Manx", label: "Manx" },
        { code: "ha", value: "Hausa", label: "Hausa" },
        { code: "haw", value: "Hawaiian", label: "Hawaiian" },
        { code: "he", value: "Hebrew", label: "Hebrew" },
        { code: "hi", value: "Hindi", label: "Hindi" },
        { code: "ho", value: "Hiri Motu", label: "Hiri Motu" },
        { code: "hr", value: "Croatian", label: "Croatian" },
        { code: "ht", value: "Haitian Creole", label: "Haitian Creole" },
        { code: "hu", value: "Hungarian", label: "Hungarian" },
        { code: "hy", value: "Armenian", label: "Armenian" },
        { code: "ia", value: "Interlingua", label: "Interlingua" },
        { code: "id", value: "Indonesian", label: "Indonesian" },
        { code: "ie", value: "Interlingue", label: "Interlingue" },
        { code: "ig", value: "Igbo", label: "Igbo" },
        { code: "ii", value: "Sichuan Yi", label: "Sichuan Yi" },
        { code: "ik", value: "Inupiaq", label: "Inupiaq" },
        { code: "io", value: "Ido", label: "Ido" },
        { code: "is", value: "Icelandic", label: "Icelandic" },
        { code: "it", value: "Italian", label: "Italian" },
        { code: "iu", value: "Inuktitut", label: "Inuktitut" },
        { code: "ja", value: "Japanese", label: "Japanese" },
        { code: "jv", value: "Javanese", label: "Javanese" },
        { code: "ka", value: "Georgian", label: "Georgian" },
        { code: "kg", value: "Kongo", label: "Kongo" },
        { code: "ki", value: "Kikuyu", label: "Kikuyu" },
        { code: "kj", value: "Kuanyama", label: "Kuanyama" },
        { code: "kk", value: "Kazakh", label: "Kazakh" },
        { code: "kl", value: "Greenlandic", label: "Greenlandic" },
        { code: "km", value: "Khmer", label: "Khmer" },
        { code: "kn", value: "Kannada", label: "Kannada" },
        { code: "ko", value: "Korean", label: "Korean" },
        { code: "kr", value: "Kanuri", label: "Kanuri" },
        { code: "ks", value: "Kashmiri", label: "Kashmiri" },
        { code: "ku", value: "Kurdish", label: "Kurdish" },
        { code: "kv", value: "Komi", label: "Komi" },
        { code: "kw", value: "Cornish", label: "Cornish" },
        { code: "ky", value: "Kyrgyz", label: "Kyrgyz" },
        { code: "la", value: "Latin", label: "Latin" },
        { code: "lb", value: "Luxembourgish", label: "Luxembourgish" },
        { code: "lg", value: "Ganda", label: "Ganda" },
        { code: "li", value: "Limburgan", label: "Limburgan" },
        { code: "ln", value: "Lingala", label: "Lingala" },
        { code: "lo", value: "Lao", label: "Lao" },
        { code: "lt", value: "Lithuanian", label: "Lithuanian" },
        { code: "lu", value: "Luba-Katanga", label: "Luba-Katanga" },
        { code: "lv", value: "Latvian", label: "Latvian" },
        { code: "mg", value: "Malagasy", label: "Malagasy" },
        { code: "mh", value: "Marshallese", label: "Marshallese" },
        { code: "mi", value: "Maori", label: "Maori" },
        { code: "mk", value: "Macedonian", label: "Macedonian" },
        { code: "ml", value: "Malayalam", label: "Malayalam" },
        { code: "mn", value: "Mongolian", label: "Mongolian" },
        { code: "mr", value: "Marathi", label: "Marathi" },
        { code: "ms", value: "Malay", label: "Malay" },
        { code: "mt", value: "Maltese", label: "Maltese" },
        { code: "my", value: "Myanmar (Burmese)", label: "Myanmar (Burmese)" },
        { code: "na", value: "Nauru", label: "Nauru" },
        { code: "nb", value: "Norwegian BokmÃ¥l", label: "Norwegian BokmÃ¥l" },
        { code: "nd", value: "North Ndebele", label: "North Ndebele" },
        { code: "ne", value: "Nepali", label: "Nepali" },
        { code: "ng", value: "Ndonga", label: "Ndonga" },
        { code: "nl", value: "Dutch", label: "Dutch" },
        { code: "nn", value: "Norwegian Nynorsk", label: "Norwegian Nynorsk" },
        { code: "no", value: "Norwegian", label: "Norwegian" },
        { code: "nr", value: "South Ndebele", label: "South Ndebele" },
        { code: "nv", value: "Navajo", label: "Navajo" },
        { code: "ny", value: "Nyanja (Chichewa)", label: "Nyanja (Chichewa)" },
        { code: "oc", value: "Occitan", label: "Occitan" },
        { code: "oj", value: "Ojibwa", label: "Ojibwa" },
        { code: "om", value: "Oromo", label: "Oromo" },
        { code: "or", value: "Oriya", label: "Oriya" },
        { code: "os", value: "Ossetian", label: "Ossetian" },
        { code: "pa", value: "Punjabi", label: "Punjabi" },
        { code: "pi", value: "Pali", label: "Pali" },
        { code: "pl", value: "Polish", label: "Polish" },
        { code: "ps", value: "Pashto", label: "Pashto" },
        { code: "pt", value: "Portuguese", label: "Portuguese" },
        { code: "qu", value: "Quechua", label: "Quechua" },
        { code: "rm", value: "Romansh", label: "Romansh" },
        { code: "rn", value: "Rundi", label: "Rundi" },
        { code: "ro", value: "Romanian", label: "Romanian" },
        { code: "ru", value: "Russian", label: "Russian" },
        { code: "rw", value: "Kinyarwanda", label: "Kinyarwanda" },
        { code: "sa", value: "Sanskrit", label: "Sanskrit" },
        { code: "sc", value: "Sardinian", label: "Sardinian" },
        { code: "sd", value: "Sindhi", label: "Sindhi" },
        { code: "se", value: "Northern Sami", label: "Northern Sami" },
        { code: "sg", value: "Sango", label: "Sango" },
        { code: "si", value: "Sinhala (Sinhalese)", label: "Sinhala (Sinhalese)" },
        { code: "sk", value: "Slovak", label: "Slovak" },
        { code: "sl", value: "Slovenian", label: "Slovenian" },
        { code: "sm", value: "Samoan", label: "Samoan" },
        { code: "sn", value: "Shona", label: "Shona" },
        { code: "so", value: "Somali", label: "Somali" },
        { code: "sq", value: "Albanian", label: "Albanian" },
        { code: "sr", value: "Serbian", label: "Serbian" },
        { code: "ss", value: "Swati", label: "Swati" },
        { code: "st", value: "Sesotho", label: "Sesotho" },
        { code: "su", value: "Sundanese", label: "Sundanese" },
        { code: "sv", value: "Swedish", label: "Swedish" },
        { code: "sw", value: "Swahili", label: "Swahili" },
        { code: "ta", value: "Tamil", label: "Tamil" },
        { code: "te", value: "Telugu", label: "Telugu" },
        { code: "tg", value: "Tajik", label: "Tajik" },
        { code: "th", value: "Thai", label: "Thai" },
        { code: "ti", value: "Tigrinya", label: "Tigrinya" },
        { code: "tk", value: "Turkmen", label: "Turkmen" },
        { code: "tl", value: "Tagalog (Filipino)", label: "Tagalog (Filipino)" },
        { code: "tn", value: "Tswana", label: "Tswana" },
        { code: "to", value: "Tonga (Tonga Islands)", label: "Tonga (Tonga Islands)" },
        { code: "tr", value: "Turkish", label: "Turkish" },
        { code: "ts", value: "Tsonga", label: "Tsonga" },
        { code: "tt", value: "Tatar", label: "Tatar" },
        { code: "tw", value: "Twi", label: "Twi" },
        { code: "ty", value: "Tahitian", label: "Tahitian" },
        { code: "ug", value: "Uyghur", label: "Uyghur" },
        { code: "uk", value: "Ukrainian", label: "Ukrainian" },
        { code: "ur", value: "Urdu", label: "Urdu" },
        { code: "uz", value: "Uzbek", label: "Uzbek" },
        { code: "ve", value: "Venda", label: "Venda" },
        { code: "vi", value: "Vietnamese", label: "Vietnamese" },
        { code: "vo", value: "VolapÃ¼k", label: "VolapÃ¼k" },
        { code: "wa", value: "Walloon", label: "Walloon" },
        { code: "wo", value: "Wolof", label: "Wolof" },
        { code: "xh", value: "Xhosa", label: "Xhosa" },
        { code: "yi", value: "Yiddish", label: "Yiddish" },
        { code: "yo", value: "Yoruba", label: "Yoruba" },
        { code: "za", value: "Zhuang", label: "Zhuang" },
        { code: "zh", value: "Chinese", label: "Chinese" },
        { code: "zu", value: "Zulu", label: "Zulu" }
    ];

}




export default Utility;